export const domain = "https://api.themoviedb.org/3";
export const apiKey = "c4f668e1970e07e21a8b225383e3fa54";
export const sessionId = "af21529e4d3b742a5d780a8d196b865c3d094862";
